import {$auth} from "@/plugins/auth"
import type {NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded} from "vue-router"
import {ROUTES} from "@/router/paths"
import routeTo from "@/plugins/route"
import {useAppStore} from "@/stores/app"
import {UserTypes} from "@/enums/UserTypes"

export default class User implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if ($auth.user && $auth.user.user_type !== UserTypes.USER) {
      useAppStore().addError('Only user accounts can access this page.')
      return cancel(routeTo(ROUTES.LOGIN))
    }

    await next(to, from, cancel)
  }
}
